(() => {
  const root = document.querySelector('[data-atlp-shipping-promo]');
  if (!root) return;

  const key = 'atlp-shipping-promo-dismissed-v1';
  try {
    if (sessionStorage.getItem(key)) return;
  } catch (_) {}

  const panel = root.querySelector('[role="dialog"]');
  const closeButton = root.querySelector('.atlp-shipping-promo__close');
  const focusable = [closeButton, root.querySelector('[data-atlp-shipping-cta]')];
  let previousFocus;
  let previousHtmlOverflow;
  let previousBodyOverflow;
  let open = false;

  function close() {
    if (!open) return;
    open = false;
    root.hidden = true;
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = previousHtmlOverflow;
    document.body.style.overflow = previousBodyOverflow;
    document.removeEventListener('keydown', onKeydown);
    try { sessionStorage.setItem(key, '1'); } catch (_) {}
    if (previousFocus && previousFocus.isConnected) previousFocus.focus();
  }

  function onKeydown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
    } else if (event.key === 'Tab') {
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      } else if (!panel.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  function show() {
    const otherModalOpen = [...document.querySelectorAll('.halo-modal, .popup-sidebar')]
      .some((modal) => modal.getClientRects().length && getComputedStyle(modal).visibility !== 'hidden');
    if (otherModalOpen || document.visibilityState !== 'visible') return;

    previousFocus = document.activeElement;
    previousHtmlOverflow = document.documentElement.style.overflow;
    previousBodyOverflow = document.body.style.overflow;
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    open = true;
    document.addEventListener('keydown', onKeydown);
    closeButton.focus();
  }

  root.querySelectorAll('[data-atlp-shipping-close]').forEach((element) => {
    element.addEventListener('click', close);
  });
  root.querySelector('[data-atlp-shipping-cta]').addEventListener('click', close);

  const schedule = () => window.setTimeout(show, 700);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }
})();

